import Vue from 'vue'
import Vuex from 'vuex'
import users from './modules/users'
import constants from './modules/constants'
import utils from './modules/utils'
import anexos from './modules/anexos'
import fotos from './modules/fotos'
import imoveis from './modules/imoveis'
import relatorios from './modules/relatorios'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    users,
    constants,
    utils,
    anexos,
    fotos,
    imoveis,
    relatorios
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/vuex/index.js